import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import auth from '../firebase';
import NavBar from './NavBar';

function ProtectedStaticPage({ slug }) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [blobUrl, setBlobUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const urlRef = useRef(null);

  useEffect(() => {
    if (!user) {
      navigate('/');
      return;
    }

    let cancelled = false;

    const fetchContent = async () => {
      try {
        const token = await auth.currentUser.getIdToken();
        const res = await fetch(`/api/content/${slug}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const html = await res.text();
        if (cancelled) return;
        if (urlRef.current) URL.revokeObjectURL(urlRef.current);
        const blob = new Blob([html], { type: 'text/html' });
        const url = URL.createObjectURL(blob);
        urlRef.current = url;
        setBlobUrl(url);
      } catch (err) {
        if (!cancelled) setError('Failed to load content. Please try again.');
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchContent();

    return () => {
      cancelled = true;
      if (urlRef.current) {
        URL.revokeObjectURL(urlRef.current);
        urlRef.current = null;
      }
    };
  }, [user, slug, navigate]);

  if (!user) return null;

  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
        <span>Loading...</span>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
        <span style={{ color: 'red' }}>{error}</span>
      </div>
    );
  }

  return (
    <>
      <NavBar />
      {/* Watermark overlay */}
      <div
        className="fixed inset-0 pointer-events-none select-none"
        style={{ zIndex: 9999, overflow: 'hidden' }}
      >
        <div style={{
          position: 'absolute', top: '50%', left: '50%',
          transform: 'translate(-50%, -50%) rotate(-35deg)',
          fontSize: '80px', fontWeight: 700,
          color: 'rgba(0,0,0,0.03)',
          whiteSpace: 'nowrap', letterSpacing: '0.1em',
          textTransform: 'uppercase', userSelect: 'none', pointerEvents: 'none',
        }}>
          CONFIDENTIAL
        </div>
      </div>
      <iframe
        src={blobUrl}
        title="content"
        sandbox="allow-scripts allow-same-origin allow-popups allow-forms allow-top-navigation-by-user-activation"
        style={{
          position: 'fixed',
          top: '36px',
          left: 0,
          width: '100%',
          height: 'calc(100% - 36px)',
          border: 'none',
          zIndex: 0,
        }}
      />
    </>
  );
}

export default ProtectedStaticPage;
